import ITrainer, { TrainerTypes } from "types/Trainer";
import ImagesUtils from "utils/images";
import { jsonEvents } from "utils/json";
import { RatedDeckData } from "utils/rating";
import { FunctionComponent, useMemo, useState } from "react";
import { IRosterSkill } from "../../types/Skill";
import Skill from "../Skill";
import Trainer from "../Trainer";
import TrainerStyles from "../Trainer/styled";
import S from "./styled";
import Select from "components/Select";
import TrainerType from "components/TrainerType";
import Utils from "utils";
import ChartComponent from "components/Chart/Chart";
import ChartUtils from "utils/chart";

type Props = {
  trainers: ITrainer[];
  skills: IRosterSkill[];
  events: (keyof typeof jsonEvents)[];
  position: string;
  team: string;
  rating: RatedDeckData["rating"];
  rank?: number;
  onTrainerClick?: (trainer: ITrainer) => any;
};

const Deck: FunctionComponent<Props> = ({ trainers, skills, rating, events, rank, position, team, onTrainerClick }) => {
  const types = useMemo(() => {
    const types = trainers.reduce((accum, curr) => {
      for (const type of curr.type) {
        if (!accum[type]) {
          accum[type] = 0;
        }

        accum[type] += 1;
      }

      return accum;
    }, {});

    return types;
  }, []);

  const [spTrainingType, setSpTrainingType] = useState(Object.keys(types)[0]);

  const parsedEvents = useMemo(() => {
    return events.map((e) => jsonEvents[e]);
  }, [events]);

  const Trainers = trainers.map((trainer) => {
    const hasEvent = parsedEvents.some((event) => {
      return event.requiredTrainers.includes(trainer.name);
    });

    return (
      <Trainer
        data={trainer}
        key={trainer.name}
        disableHover
        disableUpgrade
        comboEvent={hasEvent}
        onClick={onTrainerClick}
      />
    );
  });

  const padding = 6 - trainers.length;

  const Padding =
    padding > 0
      ? Array.from(Array(padding)).map(() => <TrainerStyles.Container style={{ background: "#131e2b" }} />)
      : [];

  const Skills = skills.sort((a, b) => b.rating - a.rating).map((skill) => <Skill data={skill} key={skill.name} />);

  return (
    <S.Container>
      <S.Deck>
        <S.Group>
          <S.GroupTitle>
            <S.DeckPlayer>
              {team && team !== "any" && <img src={ImagesUtils.getTeamImage(team as any)} style={{ width: "35px" }} />}
              <span>{position}</span>
            </S.DeckPlayer>
            Deck {rank && `#${rank}`}
            <span>Rating: {rating.total}</span>
          </S.GroupTitle>
          <S.Trainers>{[...Trainers, ...Padding]}</S.Trainers>
        </S.Group>

        <S.Group>
          <S.GroupTitle>Ratings</S.GroupTitle>
          <S.Ratings>
            <div>
              <span>Trainers:</span> {rating.rarities} points
            </div>
            <div>
              <span>Skills:</span> {rating.skills} points
            </div>
            <div>
              <span>Combo Events:</span> {rating.events} points
            </div>
            <div>
              <span>Team Bonus:</span> {rating.teamBonus} points
            </div>
            <div>
              <span>Stat Synergy:</span> {rating.statSynergy} points
            </div>
          </S.Ratings>
        </S.Group>

        <S.Group>
          <S.GroupTitle>Skills</S.GroupTitle>

          <S.Skills>{Skills}</S.Skills>
        </S.Group>

        <S.Group>
          <S.GroupTitle>Special Trainings</S.GroupTitle>

          <S.SpecialTraining>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "32px" }}>
              {Object.keys(types).map((type) => (
                <div
                  onClick={setSpTrainingType.bind(null, type)}
                  style={{
                    cursor: "pointer",
                    margin: "0 16px",
                    padding: "4px",
                    background: type === spTrainingType && "#172435",
                    borderRadius: "5px",
                  }}
                >
                  <TrainerType types={[type as TrainerTypes]} size={50} />
                </div>
              ))}
            </div>

            <div style={{ display: "flex" }}>
              <div style={{ width: "400px", margin: "auto", maxWidth: "80vw" }}>
                <ChartComponent data={ChartUtils.getSpecialTrainingsChart(trainers, spTrainingType as TrainerTypes)} />
              </div>
            </div>
          </S.SpecialTraining>
        </S.Group>
      </S.Deck>
    </S.Container>
  );
};

export default Deck;
